/* KidsnWear review form: reads the order link, restores input after a failed send, shows a sending state */
(function () {
  'use strict';
  var root = document.getElementById('knw-review-form');
  if (!root) return;
  function $(s) { return root.querySelector(s); }

  var STORE = 'knwReviewState';
  function readState() { try { return JSON.parse(sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; } }
  function writeState(s) { try { sessionStorage.setItem(STORE, JSON.stringify(s)); } catch (e) {} }
  function clearState() { try { sessionStorage.removeItem(STORE); } catch (e) {} }
  function clean(v, n) { return (v || '').replace(/[<>]/g, '').trim().slice(0, n); }
  function bringIntoView(el) {
    if (!el) return;
    setTimeout(function () {
      try {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (el.focus) el.focus({ preventScroll: true });
      } catch (e) {}
    }, 80);
  }
  var saved = readState();

  /* Success page: Shopify confirmed the send (the thank-you is only rendered by Liquid in that case) */
  var thanks = $('[data-knw-thanks]');
  if (thanks) {
    var th = $('#knw-thanks-heading');
    var tpl = th ? th.getAttribute('data-named') : '';
    var who = clean(saved.firstName || saved.nameParam, 60).split(' ')[0];
    if (th && tpl && who) th.textContent = tpl.replace('{name}', who);
    clearState();
    bringIntoView(thanks);
    return;
  }

  var form = $('form');
  if (!form) return;
  var el = form.elements;
  var errorBox = $('[data-knw-errors]');
  var restoring = !!errorBox;

  /* Link parameters: the address first, then what we saved before a failed send */
  var params = new URLSearchParams(window.location.search);
  function param(name, savedKey, n) {
    var v = params.get(name);
    if (!v && restoring) v = saved[savedKey] || '';
    return clean(v, n);
  }
  var order = param('order', 'order', 40);
  var key = param('key', 'key', 120);
  var nameParam = param('name', 'nameParam', 60);
  var productsRaw = param('products', 'products', 2000);

  el['contact[Order]'].value = order;
  el['contact[Key]'].value = key;
  var productField = el['contact[Product]'];
  var nameField = el['contact[Name]'];
  var cityField = el['contact[City]'];
  var reviewField = el['contact[Review]'];
  var btn = $('.knw-submit');
  var btnText = btn ? btn.textContent : '';
  var rateBox = $('[data-knw-rate]');
  var rateError = $('[data-knw-rate-error]');
  var picks = $('[data-knw-picks]');
  var search = $('[data-knw-search]');
  var searchInput = $('[data-knw-search-input]');
  var errorEl = $('[data-knw-error]');
  var radios = form.querySelectorAll('input[type=radio]');

  function ratingValue() {
    var v = '';
    Array.prototype.forEach.call(radios, function (r) { if (r.checked) v = r.value; });
    return v;
  }

  /* After a failed send: put back everything the customer typed and the stars they chose */
  if (restoring) {
    if (saved.typedName) nameField.value = saved.typedName;
    if (saved.city) cityField.value = saved.city;
    if (saved.review) reviewField.value = saved.review;
    if (saved.rating) {
      Array.prototype.forEach.call(radios, function (r) { if (r.value === String(saved.rating)) r.checked = true; });
    }
    bringIntoView(errorBox);
  }

  var heading = $('#knw-heading');
  if (heading && nameParam) {
    var named = heading.getAttribute('data-named');
    if (named) heading.textContent = named.replace('{name}', nameParam);
    if (!nameField.value) nameField.value = nameParam;
  }

  var handles = productsRaw.split(',')
    .map(function (h) { return h.trim().toLowerCase(); })
    .filter(function (h, i, a) { return /^[a-z0-9][a-z0-9_-]{0,254}$/.test(h) && a.indexOf(h) === i; })
    .slice(0, 8);

  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function choose(handle, btnEl) {
    productField.value = handle;
    Array.prototype.forEach.call(picks.children, function (c) {
      c.setAttribute('aria-pressed', c === btnEl ? 'true' : 'false');
    });
    errorEl.hidden = true;
  }

  function card(p) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'knw-pick';
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('data-handle', p.handle);
    if (p.featured_image) {
      var i = document.createElement('img');
      i.src = sized(p.featured_image, 160);
      i.alt = '';
      i.width = 64;
      i.height = 80;
      i.loading = 'lazy';
      b.appendChild(i);
    }
    var s = document.createElement('span');
    s.textContent = p.title;
    b.appendChild(s);
    b.addEventListener('click', function () { choose(p.handle, b); });
    return b;
  }

  function showSearch() {
    picks.hidden = true;
    search.hidden = false;
    var list = $('[data-knw-suggest]');
    var timer;
    if (restoring && saved.product) {
      productField.value = saved.product;
      searchInput.value = saved.productLabel || saved.product;
    }
    searchInput.addEventListener('input', function () {
      productField.value = clean(searchInput.value, 120);
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) { list.hidden = true; list.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            list.innerHTML = '';
            items.forEach(function (p) {
              var li = document.createElement('li');
              var b = document.createElement('button');
              b.type = 'button';
              var src = p.image || (p.featured_image && p.featured_image.url);
              if (src) {
                var im = document.createElement('img');
                im.src = sized(src, 80);
                im.alt = '';
                im.width = 36;
                im.height = 44;
                b.appendChild(im);
              }
              var sp = document.createElement('span');
              sp.textContent = p.title;
              b.appendChild(sp);
              b.addEventListener('click', function () {
                productField.value = p.handle;
                searchInput.value = p.title;
                list.hidden = true;
              });
              li.appendChild(b);
              list.appendChild(li);
            });
            list.hidden = !items.length;
          })
          .catch(function () {});
      }, 250);
    });
  }

  if (!handles.length) {
    showSearch();
  } else {
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      list = list.filter(Boolean);
      if (!list.length) { showSearch(); return; }
      list.forEach(function (p) { picks.appendChild(card(p)); });
      if (list.length === 1) {
        picks.classList.add('knw-picks--single');
        choose(list[0].handle, picks.firstChild);
      } else if (restoring && saved.product) {
        Array.prototype.forEach.call(picks.children, function (c) {
          if (c.getAttribute('data-handle') === saved.product) choose(saved.product, c);
        });
      }
    });
  }

  /* Highlight fields that fail the browser checks once the customer has tried to send */
  form.addEventListener('invalid', function () { form.classList.add('knw-tried'); }, true);
  form.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') {
      rateBox.classList.remove('knw-fieldset--missing');
      rateError.hidden = true;
    }
  });

  var sending = false;
  form.addEventListener('submit', function (e) {
    if (sending) { e.preventDefault(); return; }
    form.classList.add('knw-tried');

    if (!productField.value) {
      e.preventDefault();
      errorEl.textContent = 'Please choose the product you are reviewing.';
      errorEl.hidden = false;
      bringIntoView(picks.hidden ? searchInput : picks);
      return;
    }
    if (!ratingValue()) {
      e.preventDefault();
      rateBox.classList.add('knw-fieldset--missing');
      rateError.hidden = false;
      bringIntoView(rateBox);
      return;
    }

    var typed = (nameField.value || '').trim();
    writeState({
      order: order,
      key: key,
      nameParam: nameParam,
      products: productsRaw,
      product: productField.value,
      productLabel: searchInput ? searchInput.value : '',
      rating: ratingValue(),
      typedName: typed,
      firstName: typed.split(' ')[0],
      city: cityField.value,
      review: reviewField.value
    });

    sending = true;
    setTimeout(function () {
      if (!btn) return;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = btn.getAttribute('data-sending') || 'Sending…';
    }, 0);
  });

  /* Coming back with the browser Back button: make the button usable again */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && btn) {
      sending = false;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = btnText;
    }
  });
})();
